/**
 * Shared Lexical node registrations used by the Markdown editors.
 *
 * Keep this list in sync when adding new node types to the editor.
 */
import { CodeNode } from "@lexical/code";
import { LinkNode } from "@lexical/link";
import { ListItemNode, ListNode } from "@lexical/list";
import { HeadingNode, QuoteNode } from "@lexical/rich-text";
import { TableCellNode, TableNode, TableRowNode } from "@lexical/table";
import { LineBreakNode } from "lexical";
import { HtmlNode } from "./HtmlNode";
import { ImageNode } from "./ImageNode";

/**
 * Base editor nodes shared across all Lexical editor instances.
 */
export const BASE_EDITOR_NODES = [
  HeadingNode,
  CodeNode,
  QuoteNode,
  ListNode,
  ListItemNode,
  LinkNode,
  LineBreakNode,
  ImageNode,
  HtmlNode,
  TableNode,
  TableCellNode,
  TableRowNode,
] as const;
